import { useState, useEffect, useContext } from "react";
import { API_URLS, BEARER_TOKENS } from "./config";
import { LanguageContext } from "../locale";
import { useLanguage } from "LanguageContext";
import axios from 'axios';

export interface LanguageContextType {
  language: string;
}

export interface FaqItem {
  id: number;
  position: number;
  title: string;
  slug: string;
  content: string;
}

export interface FaqCategory {
  id: number;
  title: string;
  slug: string;
  position: number;
  items_faqs: FaqItem[];
}

export interface FaqData {
  pageTitle: string;
  paragraph: any;
  summary_title: string;
  contactButton: {
    text: string;
    email: string;
  };
  categories_faqs: FaqCategory[];
}

export function useFaqService() {
  const [faqData, setFaqData] = useState<FaqData | null>(null);
  const [loading, setLoading] = useState<Boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const lang = useLanguage();
  const domain = window.location.hostname;
  useEffect(() => {
    const fetchFaqData = async () => {
      try {
        const response = await axios.get(API_URLS.FAQ, {
         params: {
          filters: {
            frontend_types: {
              hostname: {
                $eq: domain,
              },
            },
          },
          populate: {
             categories_faqs: {
               populate: "*",
            },
            frontend_types: {
              populate: ['logo'], // populate only the logo field
            },
            contact_button: {
              populate: '*',
             },
          },
          locale: lang.language,
          }
        });

        // check response
        if (response.status != 200) {
          throw new Error("Failed to fetch FAQ data");
        }
        const json = response.data;
        const data = {
          pageTitle: json.data[0]?.page_title || "",
          paragraph:
            json.data[0]?.paragraph || "",
          summary_title: json.data[0]?.summary_title || "",
          contactButton: {
            text:
              json.data[0]?.contact_button?.button_text || "",
            email:
              json.data[0]?.contact_button?.button_email || "",
          },
          categories_faqs: json?.data[0]?.categories_faqs
            ? json?.data[0]?.categories_faqs?.sort((x:FaqCategory,y:FaqCategory)=> x?.position - y?.position)?.map((category: FaqCategory) => ({
                id: category?.id,
                title: category?.title,
                slug: category?.slug,
                items_faqs: category?.items_faqs
                  ? category.items_faqs
                      .sort((a,b)=> a?.position - b?.position).map((item) => ({
                        id: item?.id,
                        position: item?.position,
                        title: item?.title,
                        slug: item?.slug,
                        content: item?.content,
                      }))                      
                  : [],
              }))
            : [],
        };
        setFaqData(data);
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqData();
  }, [lang.language]);

  return { faqData, loading, error };
}
